var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { setupWorker } from '../workers/workerWrapper';
import { distributeNewShare } from '../core/shares/shareDistribution';
import { waitUntilTrue } from '../core/utils/pollingUtils';
function isKeygenComplete(ctx, userId, walletId) {
    return __awaiter(this, void 0, void 0, function* () {
        const wallets = yield ctx.capsuleClient.getWallets(userId);
        const wallet = wallets.data.wallets.find((w) => w.id === walletId);
        return !!wallet.address;
    });
}
export function keygen(ctx, userId, secretKey, skipDistribute = false, customFunction, sessionCookie) {
    return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
        const worker = yield setupWorker(ctx, (res) => __awaiter(this, void 0, void 0, function* () {
            yield waitUntilTrue(() => __awaiter(this, void 0, void 0, function* () { return isKeygenComplete(ctx, userId, res.walletId); }), 15000, 1000);
            if (skipDistribute) {
                resolve({
                    signer: res.signer,
                    walletId: res.walletId,
                    recoveryShare: null,
                });
                worker.terminate();
                return;
            }
            const recoveryShare = yield distributeNewShare(ctx, userId, res.walletId, res.signer);
            resolve({
                signer: res.signer,
                walletId: res.walletId,
                recoveryShare,
            });
            worker.terminate();
        }), customFunction);
        worker.postMessage({
            env: ctx.env,
            apiKey: ctx.apiKey,
            params: { userId, secretKey },
            functionType: 'KEYGEN',
            offloadMPCComputationURL: ctx.offloadMPCComputationURL,
            disableWorkers: ctx.disableWorkers,
            sessionCookie,
            useDKLS: ctx.useDKLS,
        });
    }));
}
